import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { postMember3, postMember7 } from "../../common/redux/MasterLayoutCRUD";
import { gamePlaySlice } from "./GamePlaySlice";

const { actions } = gamePlaySlice;

export const playGame = (queryParams, isDemo) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return (isDemo ? postMember7(queryParams, isDemo) : postMember3(queryParams))
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.playCompanyGame({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: companyPlayGame");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
